import * as yup from "yup";

/* eslint-disable import/prefer-default-export */

export const validationSchema = yup.object().shape({
  email: yup.string().required("Debe introducir un email").email(),
  name: yup.string().required("Debe introducir un nombre"),
});
